module.exports = __webpack_public_path__ + "static/media/fonts-2.7729ce0e.svg";